import { useEffect, useState } from 'react'

import { GetLocalPublicMemberStations } from 'types/graphql'
import { parseTemplate } from 'url-template'

import { navigate, routes } from '@cedarjs/router'

import { useAuth } from 'src/auth'
import Dropdown from 'src/components/Custom/Dropdown/Dropdown'
import { checkboxInputTag } from 'src/lib/formatters'

interface StationProps {
  station: GetLocalPublicMemberStations['stations'][number]
}

const Station = ({ station }: StationProps) => {
  const { currentUser } = useAuth()
  const isAdmin = currentUser?.roles?.includes('ADMIN')

  const dropdownLinks = [
    {
      label: 'General',
      value: 'general',
    },
    {
      label: 'Livestreams',
      value: 'livestreams',
    },
    {
      label: 'Audio streams',
      value: 'audiostreams',
    },
    {
      label: 'Users',
      value: 'users',
    },
  ]

  if (isAdmin) {
    dropdownLinks.push({
      label: 'Configuration',
      value: 'configuration',
    })
  }

  const onDropdownSelect = (option: { label: string; value: string }) => {
    if (option.value === 'general') {
      navigate(routes.editLocalStation({ id: station.id }))
    } else if (option.value === 'livestreams') {
      navigate(routes.editLocalStationLivestreams({ id: station.id }))
    } else if (option.value === 'audiostreams') {
      navigate(routes.editLocalStationAudiostreams({ id: station.id }))
    } else if (option.value === 'users') {
      navigate(routes.editLocalStationUsers({ id: station.id }))
    }

    if (isAdmin) {
      if (option.value === 'configuration') {
        navigate(routes.editStationConfiguration({ id: station.id }))
      }
    }
  }

  const [logoUrl, setLogoUrl] = useState(null)
  useEffect(() => {
    if (station.smallColorLogo?.transformTemplate) {
      const template = parseTemplate(station.smallColorLogo.transformTemplate)
      setLogoUrl(template.expand({ options: { width: 300 } }))
    }
  }, [station.smallColorLogo])

  return (
    <tr className="hover:bg-slate-100">
      <td className="relative px-3 py-4">
        {logoUrl ? (
          <img className="max-h-12" src={logoUrl} alt="station color logo" />
        ) : (
          <em>Not set</em>
        )}
      </td>
      <td className="px-3 py-4">{station.name}</td>
      <td className="px-3 py-4">
        <span className="bg-gray-100 p-1 font-mono">{station.callSign}</span>
      </td>
      <td className="px-3 py-4">
        {checkboxInputTag(!!station.isLocalPublicDemoMember)}
      </td>
      <td className="px-3 py-4">
        <Dropdown
          options={dropdownLinks}
          onOptionsChange={onDropdownSelect}
          buttonText="Edit"
        />
      </td>
    </tr>
  )
}

export default Station
